import { CatalogGridLoader } from '@/screens/catalog/ui/catalog-grid/catalog-grid-loader/catalog-grid-loader'

import { ProductCard } from '@/widgets/ProductCard'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { TProduct } from '@/shared/types/product-types'

import cl from './style.module.scss'

export interface CatalogGridProps {
	items: TProduct[]
	isLoading: boolean
}

export const CatalogGrid = (props: CatalogGridProps) => {
	const { items, isLoading } = props
	const { isMobile } = useMediaQueries()

	if (isLoading) return
	return (
		<div className={cl.products}>
			{!isLoading && items?.map(product => <ProductCard key={product.KOD} data={product} type={'wideOnMobile'} />)}
			{isLoading && <CatalogGridLoader isMobile={isMobile} />}
		</div>
	)
}
